import { render } from "./SessionCard.vue?vue&type=template&id=0d8106d4&scoped=true"
import script from "./SessionCard.vue?vue&type=script&lang=js"
export * from "./SessionCard.vue?vue&type=script&lang=js"

import "./SessionCard.vue?vue&type=style&index=0&id=0d8106d4&scoped=true&lang=css"

import exportComponent from "/Users/abinop/code/Filisia-Dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8106d4"]])

export default __exports__